"use client";
// Imports
import {
  RollerCoaster,
  TramFront,
  BusFront,
  TrafficCone,
  Pin,
  Scroll,
  Utensils,
  Car,
  Baby,
  ShoppingBag,
  Briefcase,
  BriefcaseMedical,
  GanttChart,
  Drama,
  Accessibility,
  Trophy,
  UsersRound,
  Monitor,
  MapPin,
  Calendar,
  BookOpenText,
  PawPrint,
  Wine,
  Music,
  Landmark,
  GlassWater,
  Milk,
  Soup,
} from "lucide-react";
import { TbBuildingCircus } from "react-icons/tb";
import { Toilet, Train, Clock, Drop } from "@phosphor-icons/react";

// Icon
export function Icon({ icon, size = 32, strokeWidth = 2 }) {
  switch (icon) {
    case "none":
      return null;
    case "ras-icon":
      return (
        <svg
          className="size-12"
          width="83"
          height="83"
          viewBox="0 0 83 83"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M31.0037 39.9708C31.0832 39.2074 31.2664 38.4267 31.5463 37.6495L31.6396 37.3882L3.22789 25.0251L0 39.3655L30.9761 40.2425L31.0037 39.9708Z"
            fill="#00AEEF"
          />
          <path
            d="M37.8777 50.5525L37.622 50.4666L25.1527 78.8413L39.5642 82.0498L40.4524 51.0374L40.1725 51.0133C39.388 50.9514 38.6173 50.7933 37.8777 50.5525Z"
            fill="#00AEEF"
          />
          <path
            d="M51.09 41.7969L51.0624 42.072C50.9898 42.7907 50.8239 43.5267 50.5716 44.2592L50.4852 44.5171L79.2357 57.028L82.4636 42.6876L51.09 41.7969Z"
            fill="#00AEEF"
          />
          <path
            d="M42.8993 0L42.0111 31.0434L42.2807 31.0777C43.0341 31.1706 43.7875 31.3529 44.5236 31.6211L44.7863 31.7174L57.3143 3.21197L42.8993 0Z"
            fill="#00AEEF"
          />
          <path
            d="M31.9887 45.4457L31.8677 45.2015L2.98938 56.4538L10.8967 68.8615L33.4609 47.6535L33.2812 47.4403C32.787 46.8522 32.355 46.1816 31.9887 45.4457Z"
            fill="#EC008C"
          />
          <path
            d="M50.136 36.7348L50.2535 36.9859L79.4705 25.6029L71.5632 13.1884L48.7778 34.6061L48.9472 34.8193C49.4068 35.4005 49.8077 36.047 50.136 36.7348Z"
            fill="#EC008C"
          />
          <path
            d="M47.4853 48.7333C46.915 49.2044 46.2722 49.624 45.5707 49.9747L45.3287 50.0951L56.7335 79.0751L69.2062 71.2068L47.6996 48.5544L47.4853 48.7333Z"
            fill="#EC008C"
          />
          <path
            d="M13.2537 10.843L34.5875 33.3165L34.8018 33.148C35.417 32.6666 36.0978 32.2505 36.8166 31.9203L37.0724 31.8034L25.7264 2.97473L13.2537 10.843Z"
            fill="#EC008C"
          />
        </svg>
      );

    case "wheel-chair":
    case "accessible-viewing":
    case "accessible-toilet":
      return <Accessibility size={size} strokeWidth={strokeWidth} />;

    case "car":
    case "taxi-zone":
      return <Car size={size} strokeWidth={strokeWidth} />;

    case "fork-knife":
    case "dining":
    case "food":
      return <Utensils size={size} strokeWidth={strokeWidth} />;

    case "map":
      return <Scroll size={size} strokeWidth={strokeWidth} />;

    case "location-pin":
      return <Pin size={size} strokeWidth={strokeWidth} />;

    case "safety-cone":
      return <TrafficCone size={size} strokeWidth={strokeWidth} />;

    case "clock":
      return <Clock size={size} strokeWidth={strokeWidth} />;

    case "rides":
      return <RollerCoaster size={size} strokeWidth={strokeWidth} />;

    case "kids-carnival":
    case "carnival":
      return <TbBuildingCircus className="text-lg" />;

    case "drama-masks":
      return <Drama size={size} strokeWidth={strokeWidth} />;

    case "bag":
      return <ShoppingBag size={size} strokeWidth={strokeWidth} />;

    case "road":
      return <GanttChart size={size} strokeWidth={strokeWidth} />;

    case "judging":
      return <UsersRound size={size} strokeWidth={strokeWidth} />;

    case "displays":
      return <Monitor size={size} strokeWidth={strokeWidth} />;

    case "trophy":
      return <Trophy size={size} strokeWidth={strokeWidth} />;

    case "pin":
      return <MapPin size={size} strokeWidth={strokeWidth} />;

    case "education":
    case "book":
      return <BookOpenText size={size} strokeWidth={strokeWidth} />;

    case "events":
      return <Calendar size={size} strokeWidth={strokeWidth} />;

    case "animal":
      return <PawPrint size={size} strokeWidth={strokeWidth} />;

    case "music":
      return <Music size={size} strokeWidth={strokeWidth} />;

    case "building":
      return <Landmark size={size} strokeWidth={strokeWidth} />;

    case "glass":
      return <GlassWater size={size} strokeWidth={strokeWidth} />;

    case "wine":
    case "celler-door":
      return <Wine size={size} strokeWidth={strokeWidth} />;

    case "dairy":
      return <Milk size={size} strokeWidth={strokeWidth} />;

    case "food":
      return <Soup size={size} strokeWidth={strokeWidth} />;

    case "first-aid":
      return <BriefcaseMedical size={size} strokeWidth={strokeWidth} />;

    case "up-arrow":
      return (
        <svg
          width="28"
          height="15"
          viewBox="0 0 28 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.1351 14.6354C27.019 14.7516 26.8811 14.8438 26.7294 14.9067C26.5776 14.9696 26.415 15.002 26.2507 15.002C26.0864 15.002 25.9238 14.9696 25.772 14.9067C25.6203 14.8438 25.4824 14.7516 25.3663 14.6354L13.7507 3.01817L2.13507 14.6354C1.90052 14.8699 1.5824 15.0017 1.25069 15.0017C0.91899 15.0017 0.600871 14.8699 0.36632 14.6354C0.131769 14.4008 6.5387e-09 14.0827 0 13.751C-6.5387e-09 13.4193 0.131769 13.1012 0.36632 12.8666L12.8663 0.366608C12.9824 0.250387 13.1203 0.158189 13.272 0.095284C13.4238 0.0323786 13.5864 0 13.7507 0C13.915 0 14.0776 0.0323786 14.2294 0.095284C14.3811 0.158189 14.519 0.250387 14.6351 0.366608L27.1351 12.8666C27.2513 12.9827 27.3435 13.1206 27.4064 13.2723C27.4693 13.4241 27.5017 13.5867 27.5017 13.751C27.5017 13.9153 27.4693 14.0779 27.4064 14.2297C27.3435 14.3814 27.2513 14.5193 27.1351 14.6354Z"
            fill="black"
          />
        </svg>
      );
    case "down-arrow":
      return (
        <svg
          width="28"
          height="15"
          viewBox="0 0 28 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.366578 0.366592C0.482669 0.250371 0.620532 0.158172 0.772279 0.0952669C0.924028 0.0323616 1.08668 -1.4707e-05 1.25095 -1.46927e-05C1.41522 -1.46783e-05 1.57788 0.0323616 1.72963 0.095267C1.88138 0.158172 2.01924 0.250372 2.13533 0.366592L13.751 11.9838L25.3666 0.366594C25.6011 0.132043 25.9192 0.000273566 26.251 0.000273595C26.5827 0.000273624 26.9008 0.132043 27.1353 0.366594C27.3699 0.601145 27.5016 0.919265 27.5016 1.25097C27.5016 1.58267 27.3699 1.90079 27.1353 2.13535L14.6353 14.6353C14.5192 14.7516 14.3814 14.8438 14.2296 14.9067C14.0779 14.9696 13.9152 15.002 13.751 15.002C13.5867 15.002 13.424 14.9696 13.2723 14.9067C13.1205 14.8438 12.9827 14.7516 12.8666 14.6353L0.366578 2.13534C0.250356 2.01925 0.158158 1.88139 0.0952522 1.72964C0.032346 1.57789 -2.93298e-05 1.41524 -2.93154e-05 1.25097C-2.93011e-05 1.0867 0.032346 0.924039 0.0952523 0.772292C0.158159 0.620544 0.250356 0.482683 0.366578 0.366592Z"
            fill="black"
          />
        </svg>
      );
    case "accessibility-toilet":
    case "accessible-toilet":
      return <Accessibility size={size} strokeWidth={strokeWidth} />;

    case "lost-property":
      return <Briefcase size={size} strokeWidth={strokeWidth} />;

    case "parents-room":
      return <Baby size={size} strokeWidth={strokeWidth} />;

    case "toilet":
      return <Toilet size={size} strokeWidth={strokeWidth} />;

    case "bus":
      return <BusFront size={size} strokeWidth={strokeWidth} />;

    case "train":
      return <Train size={size} strokeWidth={strokeWidth} />;

    case "tram":
      return <TramFront size={size} strokeWidth={strokeWidth} />;

    case "water-refill-stations":
      return <Drop size={size} strokeWidth={strokeWidth} />;

    case "show-wrap-up":
      return <ShowWrapUp size={size} />;

    case "about-the-show":
      return <AboutTheShow size={size} />;

    case "become-an-exhibitor":
      return <BecomeAnExhibitor size={size} />;

    case "comp_info":
      return <CompInfo size={size} />;

    case "comp-results":
      return <CompResults size={size} />;

    case "tickets":
      return <Tickets size={size} />;

    case "education-initiatives":
      return (
        <svg
          width={size}
          viewBox="0 0 49 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1_7)">
            <path
              d="M23.32 22.56C23.21 22.56 23.1 22.54 23 22.49L0.43 11.96C0.17 11.84 0 11.57 0 11.28C0 10.99 0.17 10.72 0.43 10.6L23 0.0700024C23.2 -0.0199976 23.43 -0.0199976 23.63 0.0700024L46.2 10.6C46.46 10.72 46.63 10.99 46.63 11.28C46.63 11.57 46.46 11.84 46.2 11.96L23.63 22.49C23.53 22.54 23.42 22.56 23.31 22.56H23.32ZM2.52 11.28L23.31 20.98L44.1 11.28L23.32 1.58L2.52 11.28Z"
              fill="#1A1A1A"
            />
            <path
              d="M23.32 34.6C15.62 34.6 9.51 28.62 9.25 28.36C9.11 28.22 9.03 28.03 9.03 27.83V15.49H10.53V27.5C11.67 28.54 17.02 33.09 23.32 33.09C29.62 33.09 34.97 28.53 36.11 27.5V15.49H37.61V27.83C37.61 28.03 37.53 28.22 37.39 28.36C37.13 28.61 31.02 34.6 23.32 34.6Z"
              fill="#1A1A1A"
            />
            <path d="M46.63 11.28H45.13V21.81H46.63V11.28Z" fill="#1A1A1A" />
            <path
              d="M45.88 25.57C44.64 25.57 43.63 24.56 43.63 23.32C43.63 22.08 44.64 21.07 45.88 21.07C47.12 21.07 48.13 22.08 48.13 23.32C48.13 24.56 47.12 25.57 45.88 25.57ZM45.88 22.56C45.46 22.56 45.13 22.9 45.13 23.31C45.13 23.72 45.47 24.06 45.88 24.06C46.29 24.06 46.63 23.72 46.63 23.31C46.63 22.9 46.29 22.56 45.88 22.56Z"
              fill="#1A1A1A"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_7">
              <rect width="48.14" height="34.6" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "partner-with-us":
      return (
        <svg
          width={size}
          viewBox="0 0 53 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1_12)">
            <path
              d="M21.73 45.51C20.7 45.51 19.73 45.11 19.01 44.38C18.29 43.65 17.88 42.69 17.88 41.66C17.88 40.63 18.28 39.66 19.01 38.94L20.48 37.47C21.98 35.97 24.43 35.97 25.93 37.47C27.43 38.97 27.43 41.42 25.93 42.92L24.46 44.39C23.73 45.12 22.76 45.52 21.74 45.52L21.73 45.51ZM23.21 37.83C22.61 37.83 22 38.06 21.55 38.52L20.08 39.99C19.64 40.43 19.39 41.03 19.39 41.65C19.39 42.27 19.64 42.87 20.08 43.31C20.97 44.2 22.52 44.2 23.41 43.31L24.88 41.84C25.8 40.92 25.8 39.43 24.88 38.51C24.42 38.05 23.82 37.82 23.22 37.82L23.21 37.83Z"
              fill="#1A1A1A"
            />
            <path
              d="M15.15 43.31C14.16 43.31 13.18 42.93 12.43 42.18C10.93 40.68 10.93 38.23 12.43 36.73L16.1 33.06C17.6 31.56 20.05 31.56 21.55 33.06C22.28 33.79 22.68 34.76 22.68 35.78C22.68 36.8 22.28 37.78 21.55 38.5L17.88 42.17C17.13 42.92 16.14 43.3 15.16 43.3L15.15 43.31ZM18.82 33.44C18.22 33.44 17.61 33.67 17.16 34.13L13.49 37.8C12.57 38.72 12.57 40.21 13.49 41.13C14.41 42.05 15.9 42.05 16.82 41.13L20.49 37.46C20.93 37.02 21.18 36.42 21.18 35.8C21.18 35.18 20.93 34.58 20.49 34.14C20.03 33.68 19.43 33.45 18.83 33.45L18.82 33.44Z"
              fill="#1A1A1A"
            />
            <path
              d="M10.76 38.93C9.73 38.93 8.76 38.53 8.04 37.8C7.32 37.07 6.91 36.11 6.91 35.08C6.91 34.05 7.31 33.08 8.04 32.36L11.71 28.69C13.17 27.23 15.7 27.23 17.16 28.69C17.89 29.42 18.29 30.38 18.29 31.41C18.29 32.44 17.89 33.41 17.16 34.13L13.49 37.8C12.76 38.53 11.79 38.93 10.77 38.93H10.76ZM14.43 29.05C13.8 29.05 13.21 29.3 12.77 29.74L9.1 33.41C8.66 33.85 8.41 34.45 8.41 35.07C8.41 35.69 8.66 36.29 9.1 36.73C9.99 37.62 11.54 37.62 12.43 36.73L16.1 33.06C16.54 32.62 16.79 32.02 16.79 31.4C16.79 30.78 16.54 30.18 16.1 29.74C15.66 29.3 15.06 29.05 14.44 29.05H14.43Z"
              fill="#1A1A1A"
            />
            <path
              d="M7.47 33.44C6.48 33.44 5.5 33.06 4.75 32.31C3.25 30.81 3.25 28.36 4.75 26.86L7.32 24.29C8.78 22.83 11.31 22.83 12.77 24.29C13.5 25.02 13.9 25.98 13.9 27.01C13.9 28.04 13.5 29.01 12.77 29.73L10.2 32.3C9.45 33.05 8.46 33.43 7.48 33.43L7.47 33.44ZM10.04 24.67C9.41 24.67 8.82 24.92 8.38 25.36L5.81 27.93C4.89 28.85 4.89 30.34 5.81 31.26C6.73 32.18 8.22 32.18 9.14 31.26L11.71 28.69C12.15 28.25 12.4 27.65 12.4 27.03C12.4 26.41 12.15 25.81 11.71 25.37C11.27 24.93 10.67 24.68 10.05 24.68L10.04 24.67Z"
              fill="#1A1A1A"
            />
            <path
              d="M37.46 43.31C36.47 43.31 35.49 42.93 34.74 42.18L29.07 36.51L30.13 35.45L35.8 41.12C36.72 42.04 38.21 42.04 39.13 41.12C40.05 40.2 40.05 38.71 39.13 37.79L40.19 36.73C41.69 38.23 41.69 40.68 40.19 42.18C39.44 42.93 38.45 43.31 37.47 43.31H37.46Z"
              fill="#1A1A1A"
            />
            <path
              d="M41.85 38.93C40.82 38.93 39.85 38.53 39.13 37.8L33.46 32.13L34.52 31.07L40.19 36.74C41.08 37.63 42.63 37.63 43.52 36.74C43.96 36.3 44.21 35.7 44.21 35.08C44.21 34.46 43.96 33.86 43.52 33.42L42.42 32.32L43.48 31.26L44.58 32.36C45.31 33.09 45.71 34.06 45.71 35.08C45.71 36.1 45.31 37.08 44.58 37.8C43.85 38.52 42.89 38.93 41.86 38.93H41.85Z"
              fill="#1A1A1A"
            />
            <path
              d="M30.88 45.51C29.85 45.51 28.88 45.11 28.16 44.38L25.58 41.8L26.64 40.74L29.22 43.32C30.11 44.21 31.66 44.21 32.55 43.32C32.99 42.88 33.24 42.28 33.24 41.66C33.24 41.04 32.99 40.44 32.55 40L33.61 38.94C34.34 39.67 34.74 40.63 34.74 41.66C34.74 42.69 34.34 43.66 33.61 44.38C32.88 45.1 31.92 45.51 30.89 45.51H30.88Z"
              fill="#1A1A1A"
            />
            <path
              d="M45.14 33.44C44.12 33.44 43.15 33.04 42.42 32.31L37.84 27.73L38.9 26.67L43.48 31.25C43.98 31.75 44.66 31.99 45.37 31.93C46.08 31.86 46.7 31.49 47.11 30.88C47.72 29.98 47.56 28.67 46.73 27.84L44.24 25.35L45.3 24.29L47.79 26.78C49.14 28.13 49.38 30.21 48.36 31.72C47.7 32.69 46.67 33.31 45.52 33.42C45.4 33.43 45.27 33.44 45.15 33.44H45.14Z"
              fill="#1A1A1A"
            />
            <path
              d="M44.77 25.58C44.58 25.58 44.39 25.51 44.24 25.36L35.13 16.25C34.14 15.26 32.83 14.76 31.44 14.79C30.13 14.83 28.93 15.36 28.02 16.29V17.91C28.02 21.5 25.1 24.41 21.52 24.41C20.05 24.41 18.85 23.21 18.85 21.74V13.7C18.85 12.51 19.31 11.38 20.13 10.52L22.43 8.12999C23.27 7.24999 24.34 6.62999 25.52 6.33999L39.55 2.79999C39.88 2.71999 40.22 2.86999 40.39 3.15999L49.98 20.42C50.15 20.73 50.09 21.11 49.82 21.34L45.27 25.38C45.13 25.51 44.95 25.57 44.77 25.57V25.58ZM31.6 13.28C33.33 13.28 34.96 13.95 36.19 15.18L44.8 23.79L48.38 20.62L39.36 4.38999L25.89 7.78999C24.98 8.01999 24.16 8.49999 23.51 9.16999L21.21 11.56C20.65 12.14 20.35 12.9 20.35 13.7V21.74C20.35 22.38 20.87 22.91 21.52 22.91C24.28 22.91 26.52 20.66 26.52 17.91V15.99C26.52 15.81 26.59 15.63 26.71 15.5C27.93 14.12 29.59 13.35 31.4 13.29C31.47 13.29 31.54 13.29 31.61 13.29L31.6 13.28Z"
              fill="#1A1A1A"
            />
            <path
              d="M7.35 25.39L2.79 21.35C2.53 21.12 2.46 20.73 2.63 20.43L12.23 3.15999C12.39 2.85999 12.74 2.71999 13.07 2.79999L26.5 6.18999L26.13 7.64999L13.26 4.39999L4.24 20.62L8.35001 24.26L7.35 25.38V25.39Z"
              fill="#1A1A1A"
            />
            <path
              d="M51.7825 18.241L48.9036 20.1603L49.7356 21.4084L52.6145 19.4891L51.7825 18.241Z"
              fill="#1A1A1A"
            />
            <path
              d="M0.824023 18.2412L-0.00802612 19.4893L2.87087 21.4085L3.70292 20.1604L0.824023 18.2412Z"
              fill="#1A1A1A"
            />
            <path
              d="M44.1405 0.000437468L39.346 2.87448L40.1172 4.16104L44.9118 1.287L44.1405 0.000437468Z"
              fill="#1A1A1A"
            />
            <path
              d="M8.48345 -0.0038498L7.71179 1.28244L12.5054 4.15816L13.277 2.87187L8.48345 -0.0038498Z"
              fill="#1A1A1A"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_12">
              <rect width="52.62" height="45.51" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "partners-and-sponsors":
      return (
        <svg
          width={size}
          viewBox="0 0 40 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1_27)">
            <path
              d="M20.99 6.4H18.09C17.13 6.4 16.34 5.61 16.34 4.65V1.75C16.34 0.79 17.13 0 18.09 0H20.99C21.95 0 22.74 0.79 22.74 1.75V4.65C22.74 5.61 21.95 6.4 20.99 6.4ZM18.09 1.5C17.95 1.5 17.84 1.61 17.84 1.75V4.65C17.84 4.79 17.95 4.9 18.09 4.9H20.99C21.13 4.9 21.24 4.79 21.24 4.65V1.75C21.24 1.61 21.13 1.5 20.99 1.5H18.09Z"
              fill="#1A1A1A"
            />
            <path
              d="M20.99 43.98H18.09C17.13 43.98 16.34 43.19 16.34 42.23V39.33C16.34 38.37 17.13 37.58 18.09 37.58H20.99C21.95 37.58 22.74 38.37 22.74 39.33V42.23C22.74 43.19 21.95 43.98 20.99 43.98ZM18.09 39.08C17.95 39.08 17.84 39.19 17.84 39.33V42.23C17.84 42.37 17.95 42.48 18.09 42.48H20.99C21.13 42.48 21.24 42.37 21.24 42.23V39.33C21.24 39.19 21.13 39.08 20.99 39.08H18.09Z"
              fill="#1A1A1A"
            />
            <path
              d="M37.33 16.2H34.43C33.47 16.2 32.68 15.41 32.68 14.45V11.55C32.68 10.59 33.47 9.79999 34.43 9.79999H37.33C38.29 9.79999 39.08 10.59 39.08 11.55V14.45C39.08 15.41 38.29 16.2 37.33 16.2ZM34.43 11.3C34.29 11.3 34.18 11.41 34.18 11.55V14.45C34.18 14.59 34.29 14.7 34.43 14.7H37.33C37.47 14.7 37.58 14.59 37.58 14.45V11.55C37.58 11.41 37.47 11.3 37.33 11.3H34.43Z"
              fill="#1A1A1A"
            />
            <path
              d="M4.65 34.18H1.75C0.79 34.18 0 33.39 0 32.43V29.53C0 28.57 0.79 27.78 1.75 27.78H4.65C5.61 27.78 6.4 28.57 6.4 29.53V32.43C6.4 33.39 5.61 34.18 4.65 34.18ZM1.75 29.28C1.61 29.28 1.5 29.39 1.5 29.53V32.43C1.5 32.57 1.61 32.68 1.75 32.68H4.65C4.79 32.68 4.9 32.57 4.9 32.43V29.53C4.9 29.39 4.79 29.28 4.65 29.28H1.75Z"
              fill="#1A1A1A"
            />
            <path
              d="M4.65 16.2H1.75C0.79 16.2 0 15.41 0 14.45V11.55C0 10.59 0.79 9.79999 1.75 9.79999H4.65C5.61 9.79999 6.4 10.59 6.4 11.55V14.45C6.4 15.41 5.61 16.2 4.65 16.2ZM1.75 11.3C1.61 11.3 1.5 11.41 1.5 11.55V14.45C1.5 14.59 1.61 14.7 1.75 14.7H4.65C4.79 14.7 4.9 14.59 4.9 14.45V11.55C4.9 11.41 4.79 11.3 4.65 11.3H1.75Z"
              fill="#1A1A1A"
            />
            <path
              d="M37.33 34.18H34.43C33.47 34.18 32.68 33.39 32.68 32.43V29.53C32.68 28.57 33.47 27.78 34.43 27.78H37.33C38.29 27.78 39.08 28.57 39.08 29.53V32.43C39.08 33.39 38.29 34.18 37.33 34.18ZM34.43 29.28C34.29 29.28 34.18 29.39 34.18 29.53V32.43C34.18 32.57 34.29 32.68 34.43 32.68H37.33C37.47 32.68 37.58 32.57 37.58 32.43V29.53C37.58 29.39 37.47 29.28 37.33 29.28H34.43Z"
              fill="#1A1A1A"
            />
            <path d="M20.29 24.44H18.79V38.33H20.29V24.44Z" fill="#1A1A1A" />
            <path d="M20.29 5.64999H18.79V17.9H20.29V5.64999Z" fill="#1A1A1A" />
            <path
              d="M19.54 25.19C17.33 25.19 15.52 23.39 15.52 21.17C15.52 18.95 17.32 17.15 19.54 17.15C21.76 17.15 23.56 18.95 23.56 21.17C23.56 23.39 21.76 25.19 19.54 25.19ZM19.54 18.66C18.15 18.66 17.02 19.79 17.02 21.18C17.02 22.57 18.15 23.7 19.54 23.7C20.93 23.7 22.06 22.57 22.06 21.18C22.06 19.79 20.93 18.66 19.54 18.66Z"
              fill="#1A1A1A"
            />
            <path
              d="M16.3397 22.1472L5.24594 28.5522L5.99594 29.8512L17.0897 23.4462L16.3397 22.1472Z"
              fill="#1A1A1A"
            />
            <path
              d="M6.0256 12.4997L5.2756 13.7987L16.3434 20.1887L17.0934 18.8897L6.0256 12.4997Z"
              fill="#1A1A1A"
            />
            <path
              d="M22.7341 22.1497L21.9841 23.4488L33.0779 29.8538L33.8279 28.5547L22.7341 22.1497Z"
              fill="#1A1A1A"
            />
            <path
              d="M33.0474 12.51L21.9796 18.9L22.7296 20.199L33.7974 13.809L33.0474 12.51Z"
              fill="#1A1A1A"
            />
            <path
              d="M37.52 28.82L36.14 28.23C37.09 25.99 37.57 23.62 37.57 21.17C37.57 19.3 37.28 17.45 36.72 15.68L38.15 15.22C38.76 17.14 39.07 19.14 39.07 21.17C39.07 23.82 38.55 26.39 37.52 28.82Z"
              fill="#1A1A1A"
            />
            <path
              d="M22.09 40.54L21.9 39.05C26.34 38.47 30.39 36.26 33.3 32.83L34.44 33.8C31.29 37.51 26.9 39.91 22.09 40.53V40.54Z"
              fill="#1A1A1A"
            />
            <path
              d="M16.99 40.54C12.18 39.91 7.79001 37.52 4.64001 33.81L5.78001 32.84C8.69002 36.27 12.74 38.48 17.18 39.06L16.99 40.55V40.54Z"
              fill="#1A1A1A"
            />
            <path
              d="M1.55 28.82C0.52 26.4 0 23.83 0 21.17C0 19.15 0.31 17.15 0.92 15.22L2.35 15.68C1.78 17.46 1.5 19.3 1.5 21.17C1.5 23.62 1.98 25.99 2.93 28.23L1.55 28.82Z"
              fill="#1A1A1A"
            />
            <path
              d="M4.66001 10.98L3.42001 10.13C6.56001 5.54999 11.51 2.51999 16.99 1.79999L17.18 3.28999C12.12 3.94999 7.56001 6.74999 4.65001 10.98H4.66001Z"
              fill="#1A1A1A"
            />
            <path
              d="M34.42 10.98C31.52 6.74999 26.95 3.94999 21.89 3.28999L22.08 1.79999C27.56 2.50999 32.51 5.54999 35.65 10.12L34.41 10.97L34.42 10.98Z"
              fill="#1A1A1A"
            />
            <path
              d="M33.43 45.61H30.16C29.85 45.61 29.58 45.42 29.46 45.14L21.06 23.83L22.46 23.28L30.67 44.11H33.43V45.61Z"
              fill="#1A1A1A"
            />
            <path
              d="M8.91999 45.61H5.64999V44.11H8.40999L16.62 23.28L18.02 23.83L9.62999 45.14C9.51999 45.43 9.23999 45.62 8.92999 45.62L8.91999 45.61Z"
              fill="#1A1A1A"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_27">
              <rect width="39.08" height="45.61" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "rh-hs-membership":
      return (
        <svg
          width={size}
          viewBox="0 0 43 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1_49)">
            <path
              d="M21.92 5.29001H13.1V6.79001H21.92V5.29001Z"
              fill="#1A1A1A"
            />
            <path d="M28.98 10.59H6.03999V12.09H28.98V10.59Z" fill="#1A1A1A" />
            <path d="M28.98 15.88H6.03999V17.38H28.98V15.88Z" fill="#1A1A1A" />
            <path d="M28.98 21.17H6.03999V22.67H28.98V21.17Z" fill="#1A1A1A" />
            <path d="M11.33 28.23H6.03999V29.73H11.33V28.23Z" fill="#1A1A1A" />
            <path d="M11.33 33.53H6.03999V35.03H11.33V33.53Z" fill="#1A1A1A" />
            <path
              d="M21.92 39.44C21.36 39.44 20.94 39.1 20.63 38.85C20.52 38.76 20.35 38.63 20.28 38.61C20.21 38.59 19.98 38.62 19.83 38.65C19.42 38.71 18.92 38.79 18.45 38.52C17.97 38.25 17.79 37.77 17.64 37.38C17.59 37.24 17.51 37.04 17.46 36.98C17.41 36.93 17.2 36.85 17.06 36.8C16.67 36.65 16.19 36.46 15.92 35.99C15.65 35.52 15.72 35.01 15.79 34.61C15.81 34.46 15.85 34.23 15.83 34.16C15.81 34.09 15.67 33.93 15.59 33.82C15.34 33.51 15 33.09 15 32.53C15 31.97 15.34 31.55 15.59 31.24C15.68 31.13 15.81 30.96 15.83 30.9C15.85 30.83 15.82 30.6 15.79 30.45C15.73 30.04 15.65 29.54 15.92 29.07C16.2 28.6 16.67 28.41 17.06 28.26C17.2 28.21 17.4 28.13 17.46 28.08C17.51 28.03 17.59 27.82 17.64 27.68C17.79 27.29 17.98 26.81 18.45 26.54C18.92 26.27 19.43 26.35 19.83 26.41C19.98 26.43 20.21 26.47 20.28 26.45C20.35 26.43 20.51 26.29 20.62 26.21C20.93 25.96 21.35 25.62 21.91 25.62C22.47 25.62 22.89 25.96 23.2 26.21C23.31 26.3 23.48 26.43 23.54 26.46C23.61 26.47 23.84 26.44 23.99 26.42C24.39 26.36 24.9 26.28 25.37 26.55C25.84 26.83 26.03 27.3 26.18 27.69C26.23 27.83 26.31 28.03 26.36 28.09C26.41 28.14 26.62 28.22 26.76 28.27C27.15 28.42 27.63 28.61 27.9 29.08C28.17 29.55 28.1 30.06 28.03 30.46C28.01 30.6 27.97 30.84 27.99 30.91C28.01 30.98 28.15 31.14 28.23 31.25C28.48 31.56 28.82 31.98 28.82 32.54C28.82 33.1 28.48 33.52 28.23 33.83C28.14 33.94 28.01 34.11 27.98 34.17C27.96 34.24 28 34.48 28.02 34.62C28.08 35.03 28.16 35.53 27.89 36C27.61 36.48 27.14 36.66 26.75 36.81C26.61 36.86 26.41 36.94 26.35 36.99C26.3 37.04 26.22 37.25 26.17 37.39C26.02 37.78 25.83 38.26 25.36 38.53C24.89 38.8 24.38 38.73 23.98 38.66C23.83 38.64 23.61 38.61 23.53 38.62C23.46 38.64 23.3 38.78 23.19 38.86C22.88 39.11 22.46 39.45 21.9 39.45L21.92 39.44ZM20.22 37.1C20.37 37.1 20.52 37.11 20.67 37.16C21.04 37.26 21.32 37.48 21.57 37.68C21.67 37.76 21.84 37.89 21.92 37.93C22 37.89 22.17 37.76 22.27 37.68C22.52 37.48 22.8 37.25 23.16 37.16C23.54 37.06 23.9 37.12 24.22 37.16C24.36 37.18 24.58 37.22 24.66 37.2C24.66 37.18 24.74 36.97 24.8 36.83C24.92 36.53 25.05 36.19 25.32 35.92C25.59 35.65 25.93 35.52 26.23 35.4C26.37 35.35 26.58 35.26 26.63 35.21C26.62 35.19 26.59 34.97 26.56 34.83C26.51 34.51 26.46 34.14 26.56 33.77C26.66 33.4 26.88 33.12 27.08 32.87C27.17 32.76 27.32 32.57 27.34 32.5C27.32 32.47 27.17 32.28 27.08 32.17C26.88 31.92 26.65 31.64 26.56 31.28C26.46 30.9 26.52 30.54 26.56 30.22C26.58 30.07 26.62 29.86 26.6 29.78C26.58 29.78 26.37 29.7 26.23 29.64C25.93 29.52 25.59 29.39 25.32 29.12C25.05 28.85 24.92 28.51 24.8 28.21C24.75 28.07 24.66 27.86 24.61 27.81C24.59 27.82 24.37 27.85 24.23 27.88C23.91 27.93 23.54 27.98 23.17 27.88C22.8 27.78 22.52 27.56 22.27 27.36C22.16 27.27 21.97 27.12 21.9 27.1C21.87 27.12 21.68 27.27 21.57 27.36C21.32 27.56 21.04 27.78 20.68 27.88C20.3 27.98 19.94 27.93 19.62 27.88C19.48 27.86 19.26 27.83 19.19 27.84C19.19 27.86 19.11 28.07 19.05 28.21C18.93 28.51 18.8 28.85 18.53 29.12C18.26 29.39 17.92 29.52 17.62 29.64C17.48 29.69 17.27 29.78 17.22 29.83C17.23 29.85 17.26 30.07 17.29 30.21C17.34 30.53 17.39 30.89 17.29 31.27C17.19 31.64 16.97 31.92 16.77 32.17C16.68 32.28 16.53 32.47 16.51 32.54C16.53 32.57 16.68 32.76 16.77 32.87C16.97 33.12 17.2 33.4 17.29 33.77C17.39 34.15 17.33 34.51 17.29 34.83C17.27 34.98 17.23 35.2 17.25 35.27C17.25 35.27 17.48 35.35 17.62 35.4C17.92 35.52 18.26 35.65 18.54 35.92C18.82 36.19 18.95 36.53 19.06 36.84C19.11 36.98 19.19 37.19 19.25 37.24C19.27 37.23 19.49 37.2 19.63 37.17C19.82 37.14 20.02 37.11 20.24 37.11L20.22 37.1Z"
              fill="#1A1A1A"
            />
            <path
              d="M18.4 45.61C18.26 45.61 18.13 45.57 18.01 45.5C17.79 45.36 17.65 45.12 17.65 44.86V37.22H19.15V43.65L21.59 42.43C21.8 42.32 22.05 42.32 22.26 42.43L24.7 43.65V37.22H26.2V44.86C26.2 45.12 26.07 45.36 25.84 45.5C25.62 45.64 25.34 45.65 25.11 45.53L21.92 43.93L18.73 45.53C18.62 45.58 18.51 45.61 18.39 45.61H18.4Z"
              fill="#1A1A1A"
            />
            <path
              d="M39.57 12.09H34.28V10.59H39.57C40.13 10.59 40.58 10.13 40.58 9.58V4.29C40.58 2.76 39.33 1.51 37.8 1.51V0C40.16 0 42.08 1.92 42.08 4.28V9.57C42.08 10.96 40.95 12.08 39.57 12.08V12.09Z"
              fill="#1A1A1A"
            />
            <path
              d="M32.51 42.08H25.45V40.58H32.51C33.07 40.58 33.52 40.12 33.52 39.57V4.28C33.52 3.22 33.91 2.25 34.55 1.5H5.16C3.14 1.5 1.5 3.14 1.5 5.16V39.57C1.5 40.13 1.96 40.58 2.51 40.58H18.39V42.08H2.51C1.12 42.08 0 40.95 0 39.57V5.16C0 2.32 2.32 0 5.16 0H37.8C38.21 0 38.55 0.34 38.55 0.75C38.55 1.16 38.21 1.5 37.8 1.5C36.27 1.5 35.02 2.75 35.02 4.28V39.57C35.02 40.96 33.89 42.08 32.51 42.08Z"
              fill="#1A1A1A"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_49">
              <rect width="42.08" height="45.61" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "show-history":
      return (
        <svg
          width={size}
          viewBox="0 0 53 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1_60)">
            <path d="M27.12 8.34H25.62V39.66H27.12V8.34Z" fill="#1A1A1A" />
            <path
              d="M28.13 45.16H24.62C23.73 45.16 22.9 44.71 22.4 43.94C21.3 42.25 19.72 41.36 17.83 41.36H3.6C1.62 41.36 0 39.75 0 37.76V9.29C0 7.31 1.61 5.69 3.6 5.69H6.45V7.19H3.6C2.44 7.19 1.5 8.13 1.5 9.29V37.76C1.5 38.92 2.44 39.86 3.6 39.86H17.84C20.26 39.86 22.27 40.99 23.66 43.12C23.88 43.45 24.24 43.66 24.62 43.66H28.13C28.51 43.66 28.88 43.46 29.09 43.13C30.48 41 32.5 39.87 34.91 39.87H49.15C50.31 39.87 51.25 38.93 51.25 37.77V9.29C51.25 8.13 50.31 7.19 49.15 7.19H46.3V5.69H49.15C51.13 5.69 52.75 7.3 52.75 9.29V37.76C52.75 39.74 51.14 41.36 49.15 41.36H34.91C33.03 41.36 31.45 42.25 30.34 43.94C29.84 44.7 29.01 45.15 28.12 45.15L28.13 45.16Z"
              fill="#1A1A1A"
            />
            <path
              d="M26.37 41.36C25.96 41.36 25.62 41.02 25.62 40.61C25.62 36.04 19.85 30.92 12.13 30.92C11.72 30.92 11.38 30.58 11.38 30.17V0.75C11.38 0.34 11.72 0 12.13 0C18.78 0 24.4 3.27 26.37 6.73C28.34 3.27 33.95 0 40.61 0C41.02 0 41.36 0.34 41.36 0.75V30.17C41.36 30.58 41.02 30.92 40.61 30.92C32.89 30.92 27.12 36.04 27.12 40.61C27.12 41.02 26.78 41.36 26.37 41.36ZM12.89 29.44C19.02 29.69 24.44 32.99 26.38 37.25C28.31 32.99 33.74 29.69 39.87 29.44V1.51C32.44 1.79 27.13 6.25 27.13 9.29C27.13 9.7 26.79 10.04 26.38 10.04C25.97 10.04 25.63 9.7 25.63 9.29C25.63 6.25 20.33 1.8 12.89 1.51V29.43V29.44Z"
              fill="#1A1A1A"
            />
            <path
              d="M26.37 41.36C26.16 41.36 25.96 41.27 25.82 41.12C20.84 35.67 16.03 35.67 6.44 35.67C6.03 35.67 5.69 35.33 5.69 34.92V3.60001C5.69 3.19001 6.03 2.85001 6.44 2.85001C8.65 2.85001 10.48 2.85001 12.16 2.91001L12.11 4.41001C10.64 4.36001 9.06 4.35001 7.19 4.35001V34.17C16.11 34.17 21.27 34.31 26.37 39.52C31.47 34.31 36.63 34.17 45.55 34.17V4.35001C43.69 4.35001 42.1 4.36001 40.63 4.41001L40.58 2.91001C42.27 2.85001 44.09 2.85001 46.3 2.85001C46.71 2.85001 47.05 3.19001 47.05 3.60001V34.92C47.05 35.33 46.71 35.67 46.3 35.67C36.71 35.67 31.9 35.67 26.92 41.12C26.78 41.28 26.58 41.36 26.37 41.36Z"
              fill="#1A1A1A"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_60">
              <rect width="52.75" height="45.16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "society-foundation":
      return (
        <svg
          width={size}
          height={40}
          viewBox="0 0 24 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1_65)">
            <path
              d="M11.23 30.62C9.38 30.62 5.56 30.27 2.96 27.67C0.170004 24.88 -0.0399961 20.71 3.89572e-06 19.04C3.89572e-06 18.64 0.330004 18.32 0.730004 18.31C2.4 18.26 6.57 18.47 9.36 21.26C12.15 24.05 12.35 28.22 12.31 29.89C12.31 30.29 11.98 30.61 11.58 30.62C11.47 30.62 11.35 30.62 11.22 30.62H11.23ZM1.51 19.81C1.56 21.55 1.97 24.56 4.02 26.61C6.07 28.66 9.08 29.07 10.82 29.12C10.77 27.38 10.36 24.37 8.31 22.32C6.26 20.28 3.25 19.86 1.51 19.81Z"
              fill="#1A1A1A"
            />
            <path
              d="M11.91 30.62C11.78 30.62 11.66 30.62 11.55 30.62C11.15 30.61 10.83 30.29 10.82 29.89C10.78 28.22 10.98 24.05 13.77 21.26C16.56 18.47 20.73 18.26 22.4 18.31C22.8 18.32 23.12 18.64 23.13 19.04C23.17 20.71 22.97 24.88 20.18 27.67C17.58 30.28 13.76 30.62 11.91 30.62ZM21.63 19.81C19.89 19.86 16.88 20.27 14.83 22.32C12.79 24.36 12.37 27.38 12.32 29.12C14.06 29.07 17.07 28.66 19.12 26.61C21.16 24.57 21.58 21.55 21.63 19.81Z"
              fill="#1A1A1A"
            />
            <path
              d="M11.23 39.77C9.38 39.77 5.56 39.42 2.96 36.82C0.170004 34.04 -0.0399961 29.86 3.89572e-06 28.19C3.89572e-06 27.79 0.330004 27.47 0.730004 27.46C2.39 27.44 6.57 27.62 9.36 30.41C12.15 33.2 12.35 37.37 12.31 39.04C12.31 39.44 11.98 39.76 11.58 39.77C11.47 39.77 11.35 39.77 11.22 39.77H11.23ZM1.51 28.96C1.56 30.7 1.97 33.71 4.02 35.76C6.07 37.81 9.08 38.22 10.82 38.27C10.77 36.53 10.36 33.52 8.31 31.47C6.26 29.42 3.25 29.01 1.51 28.96Z"
              fill="#1A1A1A"
            />
            <path
              d="M11.91 39.77C11.78 39.77 11.66 39.77 11.55 39.77C11.15 39.76 10.83 39.44 10.82 39.04C10.78 37.37 10.98 33.2 13.77 30.41C16.56 27.62 20.75 27.44 22.4 27.46C22.8 27.46 23.12 27.79 23.13 28.19C23.17 29.86 22.97 34.03 20.18 36.82C17.58 39.42 13.76 39.77 11.91 39.77ZM21.63 28.96C19.89 29.01 16.88 29.42 14.83 31.47C12.78 33.52 12.37 36.53 12.32 38.27C14.06 38.22 17.07 37.81 19.12 35.76C21.16 33.72 21.58 30.7 21.63 28.96Z"
              fill="#1A1A1A"
            />
            <path
              d="M11.23 21.47C9.39001 21.47 5.56001 21.12 2.95001 18.52C0.170006 15.73 -0.0399937 11.55 6.28829e-06 9.89001C6.28829e-06 9.49001 0.330006 9.17001 0.730006 9.16001C2.39001 9.14001 6.57001 9.32001 9.36001 12.11C12.15 14.9 12.35 19.07 12.31 20.74C12.31 21.14 11.98 21.46 11.58 21.47C11.47 21.47 11.36 21.47 11.23 21.47ZM1.51001 10.66C1.56001 12.4 1.97001 15.41 4.02001 17.46C6.07001 19.51 9.08001 19.92 10.82 19.97C10.77 18.23 10.36 15.22 8.31001 13.17C6.26001 11.12 3.25001 10.71 1.51001 10.66Z"
              fill="#1A1A1A"
            />
            <path
              d="M11.9 21.47C11.77 21.47 11.66 21.47 11.55 21.47C11.15 21.47 10.83 21.14 10.82 20.74C10.78 19.07 10.98 14.9 13.77 12.11C16.56 9.32 20.75 9.13 22.4 9.16C22.8 9.16 23.12 9.49 23.13 9.89C23.17 11.56 22.97 15.73 20.18 18.52C17.57 21.13 13.75 21.47 11.9 21.47ZM21.63 10.66C19.89 10.71 16.88 11.12 14.83 13.17C12.78 15.22 12.37 18.23 12.32 19.97C14.06 19.92 17.07 19.51 19.12 17.46C21.17 15.41 21.58 12.4 21.63 10.66Z"
              fill="#1A1A1A"
            />
            <path
              d="M11.57 13.98C9.16 13.98 6.7 12.35 6.66 9.23V9.11C6.66 4.83 9.73 1.46 11.05 0.199998C11.34 -0.0700024 11.79 -0.0700024 12.08 0.199998C13.4 1.45 16.47 4.82 16.47 9.11V9.24C16.43 12.35 13.97 13.98 11.56 13.98H11.57ZM11.57 1.81C10.25 3.19 8.16 5.88 8.16 9.11C8.16 9.11 8.16 9.2 8.16 9.21C8.19 11.47 9.89 12.48 11.57 12.48C13.25 12.48 14.95 11.47 14.98 9.21C14.98 5.89 12.89 3.19 11.57 1.81Z"
              fill="#1A1A1A"
            />
            <path d="M12.32 13.23H10.82V42.35H12.32V13.23Z" fill="#1A1A1A" />
          </g>
          <defs>
            <clipPath id="clip0_1_65">
              <rect width="23.13" height="42.35" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "volunteer":
      return (
        <svg
          width={size}
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1_74)">
            <path
              d="M14.1 29.04V27.54C15.53 27.54 16.69 26.38 16.69 24.95V14.29C16.69 13.35 16.09 12.52 15.19 12.21C14.83 12.09 13.99 11.8 13.47 11.62L9.63 15.46C9.34 15.75 8.86 15.75 8.57 15.46L4.73 11.62C4.21 11.8 3.37 12.09 3 12.21C2.1 12.51 1.5 13.35 1.5 14.29V24.95C1.5 26.38 2.66 27.54 4.09 27.54V29.04C1.84 29.04 0 27.21 0 24.95V14.29C0 12.71 1.01 11.3 2.52 10.79C3.06 10.61 4.68 10.05 4.68 10.05C4.95 9.96 5.25 10.02 5.46 10.23L9.1 13.87L12.74 10.23C12.94 10.03 13.24 9.96 13.52 10.05C13.52 10.05 15.14 10.61 15.68 10.79C17.19 11.3 18.2 12.7 18.2 14.29V24.95C18.2 27.2 16.37 29.04 14.11 29.04H14.1Z"
              fill="#1A1A1A"
            />
            <path
              d="M9.09999 9.85C6.38999 9.85 4.17999 7.64 4.17999 4.93C4.17999 2.22 6.37999 0 9.09999 0C11.82 0 14.02 2.21 14.02 4.92C14.02 7.63 11.81 9.84 9.09999 9.84V9.85ZM9.09999 1.5C7.20999 1.5 5.67999 3.04 5.67999 4.92C5.67999 6.8 7.21999 8.34 9.09999 8.34C10.98 8.34 12.52 6.8 12.52 4.92C12.52 3.04 10.98 1.5 9.09999 1.5Z"
              fill="#1A1A1A"
            />
            <path
              d="M13.27 43.23H4.92C4.05 43.23 3.34 42.52 3.34 41.65V17.45H4.84V41.65C4.84 41.65 4.88 41.73 4.92 41.73H13.27C13.27 41.73 13.35 41.69 13.35 41.65V17.45H14.85V41.65C14.85 42.52 14.14 43.23 13.27 43.23Z"
              fill="#1A1A1A"
            />
            <path
              d="M9.85001 27.46H8.35001V42.48H9.85001V27.46Z"
              fill="#1A1A1A"
            />
            <path
              d="M26.62 43.23C21.46 43.23 16.69 40.88 13.51 36.79L14.7 35.87C17.59 39.59 21.94 41.73 26.63 41.73C34.96 41.73 41.74 34.95 41.74 26.62C41.74 18.29 34.96 11.51 26.63 11.51C23.46 11.51 20.41 12.49 17.83 14.35L16.95 13.13C19.79 11.08 23.13 10 26.63 10C35.79 10 43.24 17.45 43.24 26.61C43.24 35.77 35.79 43.22 26.63 43.22L26.62 43.23Z"
              fill="#1A1A1A"
            />
            <path
              d="M26.62 29.88C24.83 29.88 23.37 28.42 23.37 26.63C23.37 24.84 24.83 23.38 26.62 23.38C28.41 23.38 29.87 24.84 29.87 26.63C29.87 28.42 28.41 29.88 26.62 29.88ZM26.62 24.87C25.65 24.87 24.87 25.66 24.87 26.62C24.87 27.58 25.66 28.37 26.62 28.37C27.58 28.37 28.37 27.58 28.37 26.62C28.37 25.66 27.58 24.87 26.62 24.87Z"
              fill="#1A1A1A"
            />
            <path d="M37.48 25.87H29.13V27.37H37.48V25.87Z" fill="#1A1A1A" />
            <path
              d="M31.63 8.18H21.62C20.75 8.18 20.04 7.47 20.04 6.6V4.93C20.04 4.06 20.75 3.35 21.62 3.35H31.63C32.5 3.35 33.21 4.06 33.21 4.93V6.6C33.21 7.47 32.5 8.18 31.63 8.18ZM21.61 4.84C21.61 4.84 21.53 4.88 21.53 4.92V6.59C21.53 6.59 21.57 6.67 21.61 6.67H31.62C31.62 6.67 31.7 6.63 31.7 6.59V4.92C31.7 4.92 31.66 4.84 31.62 4.84H21.61Z"
              fill="#1A1A1A"
            />
            <path d="M24.87 7.43H23.37V10.97H24.87V7.43Z" fill="#1A1A1A" />
            <path d="M29.88 7.43H28.38V10.98H29.88V7.43Z" fill="#1A1A1A" />
            <path
              d="M36.23 23.51C34.88 19.33 31.02 16.52 26.62 16.52V15.02C31.67 15.02 36.1 18.25 37.65 23.05L36.22 23.51H36.23Z"
              fill="#1A1A1A"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_74">
              <rect width="43.23" height="43.23" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "work-with-us":
      return (
        <svg
          width={size}
          viewBox="0 0 49 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1_86)">
            <path
              d="M28.83 33.09V31.59C30.35 31.59 31.59 30.35 31.59 28.83V20.05C31.59 19.04 30.95 18.15 29.99 17.83L28.18 17.37L24.97 20.58C24.83 20.72 24.64 20.8 24.44 20.8C24.24 20.8 24.05 20.72 23.91 20.58L20.7 17.37L18.84 17.84C17.93 18.14 17.29 19.03 17.29 20.04V28.82C17.29 30.34 18.53 31.58 20.05 31.58V33.08C17.7 33.08 15.79 31.17 15.79 28.82V20.04C15.79 18.38 16.85 16.92 18.42 16.4L20.74 15.81C21 15.75 21.27 15.81 21.46 16.01L24.44 18.99L27.42 16.01C27.61 15.82 27.88 15.75 28.14 15.81L30.41 16.39C32.03 16.93 33.09 18.39 33.09 20.05V28.83C33.09 31.18 31.18 33.09 28.83 33.09Z"
              fill="#1A1A1A"
            />
            <path
              d="M24.44 15.54C22.09 15.54 20.18 13.63 20.18 11.28C20.18 8.93 22.09 7.02 24.44 7.02C26.79 7.02 28.7 8.93 28.7 11.28C28.7 13.63 26.79 15.54 24.44 15.54ZM24.44 8.52C22.92 8.52 21.68 9.76 21.68 11.28C21.68 12.8 22.92 14.04 24.44 14.04C25.96 14.04 27.2 12.8 27.2 11.28C27.2 9.76 25.96 8.52 24.44 8.52Z"
              fill="#1A1A1A"
            />
            <path
              d="M28.83 45.38H20.05C19.64 45.38 19.3 45.04 19.3 44.63V21.81H20.8V43.88H28.08V21.81H29.58V44.63C29.58 45.04 29.24 45.38 28.83 45.38Z"
              fill="#1A1A1A"
            />
            <path d="M25.19 30.59H23.69V44.63H25.19V30.59Z" fill="#1A1A1A" />
            <path
              d="M13.04 33.09V31.59C14.56 31.59 15.8 30.35 15.8 28.83V20.05C15.8 19.04 15.16 18.15 14.2 17.83L12.39 17.37L9.18 20.58C8.9 20.86 8.4 20.86 8.12 20.58L4.91 17.37L3.05 17.84C2.14 18.14 1.5 19.03 1.5 20.04V28.82C1.5 30.34 2.74 31.58 4.26 31.58V33.08C1.91 33.08 0 31.17 0 28.82V20.04C0 18.38 1.06 16.92 2.63 16.4L4.95 15.81C5.21 15.75 5.48 15.81 5.67 16.01L8.65 18.99L11.63 16.01C11.82 15.82 12.09 15.75 12.35 15.81L14.63 16.39C16.25 16.93 17.31 18.39 17.31 20.05V28.83C17.31 31.18 15.4 33.09 13.05 33.09H13.04Z"
              fill="#1A1A1A"
            />
            <path
              d="M8.65001 15.54C6.30001 15.54 4.39001 13.63 4.39001 11.28C4.39001 8.93 6.30001 7.02 8.65001 7.02C11 7.02 12.91 8.93 12.91 11.28C12.91 13.63 11 15.54 8.65001 15.54ZM8.65001 8.52C7.13001 8.52 5.89001 9.76 5.89001 11.28C5.89001 12.8 7.13001 14.04 8.65001 14.04C10.17 14.04 11.41 12.8 11.41 11.28C11.41 9.76 10.17 8.52 8.65001 8.52Z"
              fill="#1A1A1A"
            />
            <path
              d="M16.55 8.52C14.2 8.52 12.29 6.61 12.29 4.26C12.29 1.91 14.2 0 16.55 0C18.9 0 20.81 1.91 20.81 4.26C20.81 6.61 18.9 8.52 16.55 8.52ZM16.55 1.5C15.03 1.5 13.79 2.74 13.79 4.26C13.79 5.78 15.03 7.02 16.55 7.02C18.07 7.02 19.31 5.78 19.31 4.26C19.31 2.74 18.07 1.5 16.55 1.5Z"
              fill="#1A1A1A"
            />
            <path
              d="M32.34 8.52C29.99 8.52 28.08 6.61 28.08 4.26C28.08 1.91 29.99 0 32.34 0C34.69 0 36.6 1.91 36.6 4.26C36.6 6.61 34.69 8.52 32.34 8.52ZM32.34 1.5C30.82 1.5 29.58 2.74 29.58 4.26C29.58 5.78 30.82 7.02 32.34 7.02C33.86 7.02 35.1 5.78 35.1 4.26C35.1 2.74 33.86 1.5 32.34 1.5Z"
              fill="#1A1A1A"
            />
            <path
              d="M13.04 45.38H4.26001C3.85001 45.38 3.51001 45.04 3.51001 44.63V21.81H5.01001V43.88H12.29V21.81H13.79V44.63C13.79 45.04 13.45 45.38 13.04 45.38Z"
              fill="#1A1A1A"
            />
            <path
              d="M9.39999 30.59H7.89999V44.63H9.39999V30.59Z"
              fill="#1A1A1A"
            />
            <path
              d="M44.63 33.09V31.59C46.15 31.59 47.39 30.35 47.39 28.83V20.05C47.39 19.04 46.75 18.15 45.79 17.83L43.98 17.37L40.77 20.58C40.63 20.72 40.44 20.8 40.24 20.8C40.04 20.8 39.85 20.72 39.71 20.58L36.5 17.37L34.64 17.84C33.73 18.14 33.09 19.03 33.09 20.04V28.82C33.09 30.34 34.33 31.58 35.85 31.58V33.08C33.5 33.08 31.59 31.17 31.59 28.82V20.04C31.59 18.38 32.65 16.92 34.22 16.4L36.54 15.81C36.8 15.75 37.07 15.81 37.26 16.01L40.24 18.99L43.22 16.01C43.41 15.82 43.68 15.75 43.94 15.81L46.21 16.39C47.83 16.93 48.89 18.39 48.89 20.05V28.83C48.89 31.18 46.98 33.09 44.63 33.09Z"
              fill="#1A1A1A"
            />
            <path
              d="M40.24 15.54C37.89 15.54 35.98 13.63 35.98 11.28C35.98 8.93 37.89 7.02 40.24 7.02C42.59 7.02 44.5 8.93 44.5 11.28C44.5 13.63 42.59 15.54 40.24 15.54ZM40.24 8.52C38.72 8.52 37.48 9.76 37.48 11.28C37.48 12.8 38.72 14.04 40.24 14.04C41.76 14.04 43 12.8 43 11.28C43 9.76 41.76 8.52 40.24 8.52Z"
              fill="#1A1A1A"
            />
            <path
              d="M44.63 45.38H35.85C35.44 45.38 35.1 45.04 35.1 44.63V21.81H36.6V43.88H43.88V21.81H45.38V44.63C45.38 45.04 45.04 45.38 44.63 45.38Z"
              fill="#1A1A1A"
            />
            <path d="M40.99 30.59H39.49V44.63H40.99V30.59Z" fill="#1A1A1A" />
          </g>
          <defs>
            <clipPath id="clip0_1_86">
              <rect width="48.89" height="45.38" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    default:
      return null;
  }
}

function ShowWrapUp({ size }) {
  return (
    <svg
      id="uuid-78d99b29-578b-408a-b2d7-b6740e6de669"
      data-name="Layer 1"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50.43 50.13"
    >
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M10.56,43.95h-1.5v-.16c0-.28-.11-.55-.31-.75l-7.47-7.47c-.83-.83-1.28-1.92-1.28-3.09v-13.79c0-1.48,1.2-2.68,2.68-2.68,1.34,0,2.48,1,2.66,2.33l1.08,8.22-1.49.2-1.08-8.22c-.08-.58-.58-1.03-1.17-1.03-.65,0-1.18.53-1.18,1.18v13.79c0,.77.3,1.49.84,2.03l7.47,7.47c.48.48.75,1.13.75,1.81v.16Z"
      />
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M23.25,43.95h-1.5v-3.46c0-3.52-2.46-6.56-5.84-7.24-.53-.11-1.08-.19-1.65-.24-1.04-.1-2-.54-2.72-1.26l-3.94-3.94c-.6-.59-1.53-.68-2.12-.2-.34.28-.54.67-.56,1.1-.02.43.14.85.44,1.15l6.31,6.31-1.06,1.06-6.31-6.31c-.6-.6-.92-1.43-.88-2.28.04-.85.45-1.65,1.11-2.19,1.18-.96,2.99-.83,4.13.3l3.94,3.94c.47.47,1.11.76,1.79.83.62.06,1.24.14,1.81.26,4.08.82,7.05,4.48,7.05,8.71v3.46Z"
      />
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M41.37,43.95h-1.5v-.16c0-.68.27-1.33.75-1.81l7.47-7.47c.54-.54.84-1.26.84-2.03v-13.79c0-.65-.53-1.18-1.18-1.18-.59,0-1.09.44-1.17,1.03l-1.08,8.22-1.49-.2,1.08-8.22c.17-1.33,1.32-2.33,2.66-2.33,1.48,0,2.68,1.2,2.68,2.68v13.79c0,1.17-.46,2.27-1.28,3.09l-7.47,7.47c-.2.2-.31.47-.31.75v.16Z"
      />
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M28.68,43.95h-1.5v-3.46c0-4.23,2.96-7.89,7.05-8.71.57-.12,1.18-.2,1.81-.26.69-.06,1.32-.36,1.79-.83l3.94-3.94c1.13-1.13,2.95-1.26,4.13-.3.66.54,1.07,1.34,1.11,2.19.04.85-.28,1.68-.88,2.28l-6.31,6.31-1.06-1.06,6.31-6.31c.3-.3.46-.72.44-1.15-.02-.43-.22-.82-.56-1.1-.59-.49-1.52-.4-2.12.2l-3.94,3.94c-.72.72-1.68,1.16-2.72,1.26-.57.05-1.13.13-1.65.24-3.39.68-5.84,3.73-5.84,7.24v3.46Z"
      />
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M22.5,50.13H8c-.41,0-.75-.34-.75-.75v-5.44c0-.41.34-.75.75-.75h14.5c.41,0,.75.34.75.75v5.44c0,.41-.34.75-.75.75ZM8.75,48.63h13v-3.94h-13v3.94Z"
      />
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M42.43,50.13h-14.5c-.41,0-.75-.34-.75-.75v-5.44c0-.41.34-.75.75-.75h14.5c.41,0,.75.34.75.75v5.44c0,.41-.34.75-.75.75ZM28.68,48.63h13v-3.94h-13v3.94Z"
      />
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M21.95,13.87h-.01l-9.85-.28c-.15,0-.29-.08-.38-.19-.09-.12-.13-.27-.09-.42l1.03-4.58c.03-.15.13-.27.26-.34.13-.07.29-.07.43-.01l9.04,3.95c.24.1.36.38.27.62-.11.3-.16.51-.18.71v.09c-.03.26-.25.45-.51.45ZM12.72,12.6l8.8.25s.02-.08.03-.12l-8.07-3.53-.76,3.4Z"
      />
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M24.69,27.23s-.07,0-.11-.01l-4.58-1.03c-.15-.03-.27-.13-.34-.26-.07-.13-.07-.29-.01-.43l3.97-9.07c.1-.24.37-.36.62-.27l-.08.5.16-.48c.2.07.41.11.62.13.26.02.56.25.55.52l-.28,9.91c0,.15-.08.29-.19.38-.09.07-.2.11-.31.11ZM20.8,25.35l3.4.76.25-8.86s-.07-.01-.1-.02l-3.55,8.12Z"
      />
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M37.3,19.23c-.07,0-.14-.01-.2-.04l-9.14-4c-.24-.1-.36-.37-.27-.62.1-.28.14-.48.16-.67.03-.26.24-.56.52-.54l9.98.28c.15,0,.29.08.38.19.09.12.13.27.09.42l-1.03,4.58c-.03.15-.13.27-.26.34-.07.04-.15.05-.23.05ZM28.76,14.45l8.18,3.58.76-3.4-8.93-.25s-.01.05-.02.08Z"
      />
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M26.35,11.14c-.06,0-.12,0-.17-.03-.28-.1-.48-.15-.68-.18-.26-.03-.53-.26-.53-.52l.28-9.92c0-.15.08-.29.19-.38.12-.09.27-.13.42-.09l4.58,1.03c.15.03.27.13.34.26.07.13.07.29.01.43l-3.98,9.11c-.08.19-.26.3-.46.3ZM25.97,10s.06.01.09.02l3.56-8.14-3.4-.76-.25,8.88Z"
      />
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M15.57,23.01s-.04,0-.06,0c-.15-.02-.28-.1-.36-.23l-2.52-3.97c-.08-.13-.1-.28-.05-.42.05-.14.15-.26.29-.31l9.19-3.6c.24-.1.51.01.63.24,0,0,.04.08.04.08.1.2.22.38.35.54.17.2.21.57.02.75l-7.18,6.78c-.09.09-.22.14-.34.14ZM13.8,18.79l1.87,2.94,6.41-6.06s-.04-.07-.07-.1l-8.21,3.22Z"
      />
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M28.09,12.82c-.19,0-.37-.11-.45-.29l.42-.29-.45.21c-.09-.19-.2-.36-.32-.52-.16-.2-.19-.56,0-.74l7.25-6.85c.11-.1.25-.15.41-.13.15.02.28.1.36.23l2.52,3.97c.08.13.1.28.05.42-.05.14-.15.26-.29.31l-9.29,3.64c-.06.02-.12.03-.18.03ZM28.28,11.63s.03.04.04.07l8.31-3.25-1.87-2.94-6.49,6.13Z"
      />
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M30.15,26.28c-.05,0-.1,0-.16-.02-.14-.05-.26-.15-.31-.29l-3.63-9.26c-.09-.24,0-.51.24-.63.27-.14.44-.25.59-.37h0s.07-.06.07-.06c.2-.17.5-.15.68.04l6.84,7.24c.1.11.15.26.13.41-.02.15-.1.28-.23.36l-3.97,2.52c-.08.05-.17.08-.27.08ZM27.14,16.74l3.25,8.29,2.94-1.87-6.12-6.47s-.05.03-.07.05ZM27.2,16.08h0s0,0,0,0h0Z"
      />
      <path
        className="fill-[#1a1a1a] stroke-none"
        d="M23.08,11.62c-.13,0-.25-.04-.34-.13l-6.79-7.18c-.1-.11-.15-.26-.13-.41.02-.15.1-.28.23-.36l3.97-2.52c.13-.08.28-.1.42-.05.14.05.26.15.31.29l3.61,9.22c.1.25-.02.53-.26.64-.27.12-.45.24-.62.37-.11.08-.26.13-.4.13ZM17.1,4.06l6.07,6.42s.06-.04.1-.06l-3.22-8.23-2.94,1.87Z"
      />
    </svg>
  );
}

function AboutTheShow({ size }) {
  return (
    <svg
      id="uuid-d004ed59-ff4a-4a76-854c-6a3d8804b5a3"
      data-name="Layer 1"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 45.61 45.61"
    >
      <path
        className="fill-black stroke-none"
        d="M17.32,23.14h-.02l-16.57-.47c-.22,0-.43-.11-.57-.29-.14-.18-.19-.41-.14-.62l1.73-7.71c.05-.22.19-.4.39-.5s.43-.11.64-.02l15.2,6.65c.36.16.54.57.41.94l-.05.14c-.13.36-.21.72-.25,1.07h0s-.02.15-.02.15c-.04.38-.36.67-.75.67ZM1.68,21.19l14.99.43c.02-.12.05-.23.08-.35L3.01,15.26l-1.33,5.93Z"
      />
      <path
        className="fill-black stroke-none"
        d="M21.92,45.61c-.05,0-.11,0-.16-.02l-7.71-1.73c-.22-.05-.4-.19-.5-.39-.1-.2-.11-.43-.02-.64l6.67-15.25c.15-.35.55-.53.92-.41l.14.04h0c.34.11.7.19,1.05.22h.15c.4.05.7.38.69.78l-.47,16.67c0,.22-.11.43-.29.57-.13.1-.3.16-.46.16ZM15.26,42.61l5.93,1.33.43-15.08c-.11-.02-.21-.04-.32-.07l-6.04,13.82Z"
      />
      <path
        className="fill-black stroke-none"
        d="M43.14,32.16c-.1,0-.2-.02-.3-.06l-15.38-6.73c-.36-.16-.53-.56-.41-.93l.05-.14c.12-.34.19-.69.23-1.01l.02-.15c.04-.38.36-.67.75-.67h.02l16.78.48c.22,0,.43.11.57.29.14.18.19.41.14.62l-1.73,7.71c-.05.22-.19.4-.39.5-.11.05-.22.08-.34.08ZM28.67,24.26l13.94,6.09,1.33-5.93-15.2-.43c-.02.09-.04.18-.06.27Z"
      />
      <path
        className="fill-black stroke-none"
        d="M24.71,18.55c-.09,0-.17-.01-.26-.05l-.14-.05c-.34-.12-.69-.21-1.03-.25l-.15-.02c-.38-.05-.67-.38-.65-.77l.48-16.69c0-.22.11-.43.29-.57s.4-.19.62-.14l7.71,1.73c.22.05.4.19.5.39.1.2.11.43.02.64l-6.7,15.33c-.12.28-.4.45-.69.45ZM23.99,16.8c.1.02.2.05.3.07l6.06-13.87-5.93-1.33-.43,15.12Z"
      />

      <path
        className="fill-black stroke-none"
        d="M6.58,38.52s-.06,0-.09,0c-.22-.03-.42-.15-.54-.34l-4.23-6.67c-.12-.19-.15-.42-.08-.63s.23-.38.44-.46l15.45-6.05c.36-.14.77.01.94.36l.07.13s0,0,0,0c.17.34.37.65.59.92l.1.12c.25.3.23.75-.06,1.02l-12.07,11.4c-.14.13-.32.21-.51.21ZM3.47,31.47l3.26,5.13,10.92-10.31c-.07-.1-.13-.2-.19-.3l-13.98,5.47Z"
      />
      <path
        className="fill-black stroke-none"
        d="M27.64,21.38c-.28,0-.55-.16-.68-.43l-.06-.13s0,0,0,0c-.15-.32-.34-.62-.55-.89l-.09-.11c-.24-.3-.21-.74.07-1.01l12.19-11.51c.16-.15.39-.23.61-.2.22.03.42.15.54.34l4.23,6.67c.12.19.15.42.08.63s-.23.38-.44.46l-15.63,6.12c-.09.04-.18.05-.27.05ZM27.84,19.45c.05.08.1.16.15.24l14.16-5.54-3.26-5.14-11.05,10.44Z"
      />
      <path
        className="fill-black stroke-none"
        d="M31.1,44.02c-.08,0-.16-.01-.23-.04-.21-.07-.38-.23-.46-.44l-6.1-15.58c-.14-.36.02-.77.36-.94l.13-.06c.32-.16.62-.36.88-.57l.12-.1c.3-.25.75-.23,1.02.06l11.5,12.18c.15.16.23.39.2.61-.03.22-.15.42-.34.54l-6.67,4.23c-.12.08-.26.12-.4.12ZM25.94,28.03l5.53,14.12,5.14-3.26-10.42-11.03c-.08.06-.16.11-.25.16Z"
      />
      <path
        className="fill-black stroke-none"
        d="M19.25,19.41c-.2,0-.4-.08-.54-.24L7.3,7.09c-.15-.16-.23-.39-.2-.61.03-.22.15-.42.34-.54L14.11,1.72c.19-.12.42-.15.63-.08.21.07.38.23.46.44l6.07,15.5c.14.37-.02.79-.38.95l-.14.06c-.33.15-.65.34-.93.57l-.11.09c-.14.11-.3.16-.46.16ZM9.01,6.73l10.33,10.94c.09-.06.19-.12.29-.18L14.15,3.47l-5.14,3.26Z"
      />
    </svg>
  );
}

function BecomeAnExhibitor({ size }) {
  return (
    <svg
      width={size}
      id="uuid-bd1e5295-4ecf-4abb-903f-621a17e4aa33"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 45.61 45.61"
    >
      <path
        className="fill-black stroke-none"
        d="M19.27,45.61c-1.34,0-2.6-.52-3.54-1.47l-2.26-2.26c-.54-.54-.63-1.39-.22-2.03.73-1.13,1.01-2.51.78-3.87-.37-2.23-2.18-4.04-4.41-4.41-1.36-.23-2.73.05-3.87.78-.64.41-1.49.32-2.03-.22l-2.26-2.26c-1.95-1.95-1.95-5.13,0-7.08L22.79,1.46c1.95-1.95,5.13-1.95,7.08,0l2.26,2.26c.54.54.63,1.39.22,2.03-.73,1.13-1.01,2.51-.78,3.87.37,2.23,2.18,4.04,4.41,4.41,1.36.23,2.74-.05,3.87-.78.64-.41,1.49-.32,2.03.22l2.26,2.26c1.95,1.95,1.95,5.13,0,7.08l-21.33,21.33c-.95.95-2.21,1.47-3.54,1.47ZM8.7,30c.39,0,.78.03,1.17.1,2.85.47,5.17,2.79,5.64,5.64.29,1.73-.07,3.48-1,4.93-.03.05-.02.11.02.15l2.26,2.26c1.33,1.33,3.64,1.33,4.96,0l21.33-21.33c1.37-1.37,1.37-3.6,0-4.96l-2.26-2.26s-.1-.05-.15-.02c-1.45.94-3.2,1.29-4.93,1-2.85-.47-5.17-2.8-5.64-5.64-.29-1.73.07-3.48,1-4.93.03-.05.02-.11-.02-.15l-2.26-2.26c-1.37-1.37-3.59-1.37-4.96,0L2.52,23.85c-1.37,1.37-1.37,3.6,0,4.96l2.26,2.26s.11.05.15.02c1.12-.72,2.42-1.1,3.76-1.1Z"
      />
      <rect
        className="fill-black stroke-none"
        x="17.97"
        y="6.79"
        width="1.5"
        height=".91"
        transform="translate(.36 15.36) rotate(-45)"
      />
      <rect
        className="fill-black stroke-none"
        x="28.42"
        y="6.04"
        width="1.5"
        height="23.32"
        transform="translate(-3.97 25.81) rotate(-45)"
      />
      <path
        className="fill-black stroke-none"
        d="M19.3,33.26c-.1,0-.21,0-.31-.03-.67-.12-1.2-.59-1.39-1.25l-.83-2.9c-.04-.12-.13-.22-.25-.25l-2.9-.83c-.65-.19-1.13-.72-1.25-1.39-.12-.67.15-1.34.71-1.74l2.69-1.94c.09-.07.15-.18.15-.3l.05-3.26c0-.66.38-1.26.98-1.56.59-.3,1.3-.24,1.83.16l2.48,1.82c.1.07.23.09.34.05l2.96-1.07c.65-.23,1.36-.08,1.84.41.49.49.65,1.2.41,1.84l-1.07,2.96c-.04.12-.02.25.05.35l1.82,2.48c.39.53.45,1.24.16,1.83-.3.59-.89.97-1.56.98l-3.27.05c-.12,0-.23.06-.29.15l-1.94,2.69c-.34.47-.87.74-1.43.74ZM17.74,19.14c-.05,0-.09.02-.12.03-.05.03-.15.09-.15.24l-.05,3.26c0,.59-.3,1.14-.77,1.49l-2.69,1.94c-.12.09-.12.2-.11.26,0,.06.05.16.18.2l2.9.83h0c.63.18,1.11.66,1.28,1.28l.83,2.9c.04.13.14.17.2.18.06.01.18.01.26-.11l1.94-2.69c.34-.48.9-.77,1.49-.78l3.27-.05c.14,0,.21-.09.23-.15.03-.05.06-.16-.02-.27l-1.82-2.49c-.37-.51-.46-1.16-.25-1.75l1.07-2.96c.05-.13-.02-.23-.06-.27-.04-.04-.14-.11-.27-.06l-2.96,1.07c-.59.21-1.24.12-1.74-.25l-2.48-1.82c-.05-.04-.11-.05-.15-.05Z"
      />
    </svg>
  );
}

function CompInfo({ size }) {
  return (
    <svg
      id="uuid-4585c260-0a48-4278-8b6f-decdfb04fdbb"
      data-name="Layer 1"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53.62 42.04"
    >
      <rect
        className="fill-black stroke-none"
        x="26.06"
        y="27.77"
        width="1.5"
        height="13.51"
      />
      <rect
        className="fill-black stroke-none"
        x="26.06"
        y="4.61"
        width="1.5"
        height="1.93"
      />
      <path
        className="fill-black stroke-none"
        d="M26.81,28.52c-6.27,0-11.37-5.1-11.37-11.37s5.1-11.37,11.37-11.37,11.37,5.1,11.37,11.37-5.1,11.37-11.37,11.37ZM26.81,7.29c-5.44,0-9.87,4.43-9.87,9.87s4.43,9.87,9.87,9.87,9.87-4.43,9.87-9.87-4.43-9.87-9.87-9.87Z"
      />
      <path
        className="fill-black stroke-none"
        d="M40.49,34.32c-.93,0-1.8-.36-2.46-1.02l-6.43-6.43,1.06-1.06,6.43,6.43c.75.75,2.05.75,2.8,0,.77-.77.77-2.03,0-2.8l-6.43-6.43,1.06-1.06,6.43,6.43c1.36,1.36,1.36,3.56,0,4.92-.66.66-1.53,1.02-2.46,1.02Z"
      />
      <path
        className="fill-black stroke-none"
        d="M27.56,21.02h-1.5v-.97c0-1.43,1.13-2.36,2.03-3.1l.08-.07c.5-.41.78-1.01.78-1.66,0-1.18-.96-2.15-2.15-2.15s-2.15.96-2.15,2.15h-1.5c0-2.01,1.64-3.65,3.65-3.65s3.65,1.64,3.65,3.65c0,1.09-.48,2.12-1.33,2.81l-.08.07c-.73.6-1.49,1.22-1.49,1.94v.97Z"
      />
      <path
        className="fill-black stroke-none"
        d="M26.81,42.04c-.28,0-.54-.16-.67-.41-1.05-2.09-3.24-3.45-5.58-3.45H4.61c-.41,0-.75-.34-.75-.75V.75c0-.41.34-.75.75-.75h15.95c2.47,0,4.8,1.22,6.25,3.18,1.44-1.96,3.78-3.18,6.25-3.18h15.95c.41,0,.75.34.75.75v36.68c0,.41-.34.75-.75.75h-15.95c-2.34,0-4.53,1.35-5.58,3.45-.13.25-.39.42-.67.42ZM5.36,36.68h15.2c2.47,0,4.8,1.22,6.25,3.18,1.44-1.96,3.78-3.18,6.25-3.18h15.2V1.5h-15.2c-2.34,0-4.53,1.35-5.58,3.45-.25.51-1.09.51-1.34,0-1.05-2.09-3.24-3.45-5.58-3.45H5.36v35.18Z"
      />
      <path
        className="fill-black stroke-none"
        d="M52.87,42.04H.75c-.41,0-.75-.34-.75-.75V4.61c0-.41.34-.75.75-.75h3.86v1.5H1.5v35.18h50.62V5.36h-3.11v-1.5h3.86c.41,0,.75.34.75.75v36.68c0,.41-.34.75-.75.75Z"
      />
    </svg>
  );
}

function CompResults({ size }) {
  return (
    <svg
      width={28}
      viewBox="0 0 31 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_2)">
        <path
          d="M19.09 36.98C18.78 36.98 18.48 36.9 18.19 36.75L15.33 35.16C15.19 35.08 15.02 35.08 14.88 35.16L12.02 36.75C11.4 37.1 10.65 37.06 10.06 36.65C9.47001 36.24 9.18001 35.54 9.30001 34.83L9.88001 31.28C9.90001 31.13 9.86001 30.99 9.75001 30.88L7.28001 28.34C6.79001 27.84 6.63001 27.12 6.85001 26.46C7.07001 25.8 7.64001 25.32 8.33001 25.22L11.63 24.71C11.78 24.69 11.92 24.59 11.98 24.45L13.43 21.35C13.74 20.69 14.38 20.29 15.1 20.29C15.82 20.29 16.47 20.7 16.77 21.35L18.22 24.45C18.29 24.59 18.42 24.69 18.57 24.71L21.88 25.22C22.57 25.33 23.13 25.8 23.35 26.46C23.57 27.12 23.41 27.84 22.92 28.34L20.45 30.88C20.35 30.99 20.3 31.14 20.32 31.28L20.9 34.83C21.02 35.54 20.72 36.23 20.14 36.65C19.82 36.87 19.45 36.99 19.08 36.99L19.09 36.98ZM15.11 33.59C15.44 33.59 15.77 33.67 16.07 33.84L18.93 35.43C19.1 35.52 19.23 35.46 19.29 35.41C19.34 35.37 19.47 35.26 19.44 35.06L18.86 31.51C18.76 30.9 18.96 30.27 19.39 29.83L21.86 27.28C22 27.14 21.96 26.98 21.94 26.92C21.92 26.86 21.85 26.71 21.66 26.68L18.35 26.17C17.7 26.07 17.15 25.66 16.87 25.06L15.42 21.96C15.34 21.78 15.17 21.76 15.11 21.76C15.05 21.76 14.88 21.78 14.8 21.96L13.35 25.06C13.07 25.66 12.52 26.07 11.87 26.17L8.57001 26.68C8.38001 26.71 8.31001 26.86 8.29001 26.92C8.27001 26.98 8.24001 27.14 8.37001 27.28L10.84 29.82C11.27 30.26 11.47 30.89 11.37 31.51L10.79 35.06C10.76 35.26 10.88 35.37 10.94 35.41C11.01 35.46 11.14 35.52 11.3 35.43L14.16 33.84C14.46 33.67 14.79 33.59 15.11 33.59Z"
          fill="#1A1A1A"
        />
        <path
          d="M15.11 43.74C6.78 43.74 0 36.96 0 28.63C0 20.3 6.78 13.52 15.11 13.52C23.44 13.52 30.22 20.3 30.22 28.63C30.22 36.96 23.44 43.74 15.11 43.74ZM15.11 15.02C7.61 15.02 1.5 21.13 1.5 28.63C1.5 36.13 7.61 42.24 15.11 42.24C22.61 42.24 28.72 36.13 28.72 28.63C28.72 21.13 22.61 15.02 15.11 15.02Z"
          fill="#1A1A1A"
        />
        <path
          d="M20.08 14.9H18.58V1.5H11.63V14.9H10.13V0.75C10.13 0.34 10.47 0 10.88 0H19.33C19.74 0 20.08 0.34 20.08 0.75V14.9Z"
          fill="#1A1A1A"
        />
        <path
          d="M23.82 17.31L22.7 16.31L26.79 11.71C26.94 11.54 27.03 11.32 27.03 11.09V2.44C27.03 1.92 26.61 1.5 26.09 1.5H4.13C3.61 1.5 3.19 1.92 3.19 2.44V11.09C3.19 11.32 3.27 11.54 3.43 11.71L7.52 16.31L6.4 17.31L2.31 12.71C1.91 12.26 1.69 11.69 1.69 11.09V2.44C1.69 1.09 2.78 0 4.13 0H26.09C27.43 0 28.53 1.09 28.53 2.44V11.09C28.53 11.69 28.31 12.26 27.91 12.71L23.82 17.31Z"
          fill="#1A1A1A"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_2">
          <rect width="30.22" height="43.74" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Tickets({}) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.92 16.97L16.84 16.34M11.55 24.86L6.18 25.59C5.97 24.04 4.54 22.95 2.99 23.16L0.5 4.9C2.05 4.69 3.14 3.26 2.93 1.71L11.83 0.5C11.84 0.6 11.86 0.7 11.89 0.79C11.9 0.84 11.91 0.89 11.93 0.94C11.93 0.97 11.95 1 11.96 1.03C11.97 1.09 12 1.14 12.02 1.2C12.04 1.25 12.06 1.29 12.08 1.34C12.25 1.7 12.5 2.03 12.8 2.28C12.87 2.34 12.95 2.4 13.02 2.45C13.06 2.48 13.09 2.5 13.13 2.52C13.17 2.54 13.21 2.56 13.24 2.59C13.33 2.64 13.41 2.68 13.5 2.72C13.6 2.77 13.7 2.81 13.81 2.83C13.85 2.84 13.89 2.86 13.93 2.87C13.97 2.88 14.01 2.89 14.05 2.9C14.11 2.91 14.16 2.92 14.22 2.93C14.31 2.94 14.4 2.95 14.49 2.95C14.66 2.95 14.83 2.95 15.01 2.93M15.01 2.93L15.35 5.4M15.01 2.93C13.46 3.14 12.03 2.05 11.82 0.5M2.98 23.16C4.53 22.95 5.96 24.04 6.17 25.59M11.94 15.84L11.33 13.9L13.22 11.48L10.15 11.45L8.43 8.91L7.46 11.81L4.51 12.66L6.98 14.49L6.87 17.55L9.37 15.77L11.69 16.62M15.39 5.29C16.88 5.78 18.48 4.96 18.97 3.47M27.5 6.26C27.01 7.75 27.83 9.35 29.32 9.84M9.67 22.81C11.16 23.3 11.97 24.9 11.49 26.39M23.59 27.35L29.31 9.83C27.82 9.34 27.01 7.74 27.49 6.25L18.96 3.46C18.47 4.95 16.87 5.76 15.38 5.28L9.66 22.8C11.15 23.29 11.96 24.89 11.48 26.38L20.01 29.17C20.5 27.68 22.1 26.87 23.59 27.35ZM20.78 12.35L21.22 15.39L23.97 16.75L21.22 18.1L20.77 21.14L18.63 18.94L15.61 19.45L17.04 16.74L15.62 14.02L18.64 14.54L20.78 12.35Z"
        stroke="black"
        strokeLinejoin="round"
      />
    </svg>
  );
}
